import css from './InputWrap.module.scss'

// name is required to connect label to input
export default function InputWrap({ label, helpText, name, component, icon, iconClickFunc, boxStyles }) {
	return (
		<div className={css['box']} style={boxStyles}>
			{/* <label htmlFor={name}>{label}</label> */}
			{label && <label className={css['label']} htmlFor={name}>{label}</label>}
			{icon && <i className={icon + ' ' + css['icon']} onClick={iconClickFunc} />}
			{component}
			{helpText && <span className={css['help-text']}>{helpText}</span>}
		</div>
	)
}
